import { Injectable } from '@angular/core';
import { UserIdleService } from 'angular-user-idle';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ExtendedUserIdleService extends UserIdleService {
    public activityEvents$: Observable<any>;
}
